export default __webpack_public_path__ + "static/media/noti--red.f7fc5b1f.svg";